import React from 'react';
import { useMediaQuery } from 'react-responsive';

import {
  MEDIA_QUERY_SMALL_SCREEN,
  MEDIA_QUERY_MEDIUM_SCREEN,
  MEDIA_QUERY_LARGE_SCREEN_1080,
} from 'client/constants/mediaQueries';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import SrGridRow from 'client/components/SrGridRow/SrGridRow';
import SrQuoteCard from 'client/components/SrQuoteCard/SrQuoteCard';

const PartnerAgentOwnerMarketingPageTestimonials = () => {
  const isSmallScreen = useMediaQuery({
    query: MEDIA_QUERY_SMALL_SCREEN,
  });

  const isMediumScreen = useMediaQuery({
    query: MEDIA_QUERY_MEDIUM_SCREEN,
  });

  const isLargeScreen = useMediaQuery({
    query: MEDIA_QUERY_LARGE_SCREEN_1080,
  });

  return (
    <SrBox padding={isSmallScreen ? '72px 0 0' : '120px 0 0'} maxWidth="1160px" margin="0 auto">
      <SrText
        font="greycliff"
        color="blueGreycliff"
        size={isSmallScreen ? '40' : '48'}
        lineHeight={isSmallScreen ? '56px' : '60px'}
        weight="700"
        align="center"
        display="block"
      >
        Happy Property Owners
      </SrText>
      <SrBox marginTop={isSmallScreen ? '30px' : '78px'}>
        <SrGridRow
          columns={isMediumScreen ? 1 : isLargeScreen ? 2 : 3}
          maxWidth="100%"
          columnGap={isLargeScreen ? '16px' : '40px'}
          rowGap={isLargeScreen ? '16px' : '32px'}
        >
          <SrQuoteCard
            headline="Leased in 5 days, yes!!"
            title="Property Owner"
            text="Thank you so much for helping me lease my home. That was so easy!"
            imageUrl="/images/monica-lopez.jpg"
            name="Monica Lopez"
          />
          <SrQuoteCard
            headline="Optimized my cash flow!"
            title="Real Estate Investor"
            text="I couldn’t believe the analytics and stats I could pull up on my phone, on the go."
            imageUrl="/images/vincent-smith.jpg"
            name="Vincent Smith"
          />
          <SrQuoteCard
            headline="Awesome work!"
            title="First-Time Landlord"
            text="The photos you took look great, thanks for finding me such amazing tenants!"
            imageUrl="/images/thomas-t.jpg"
            name="Thomas T."
          />
        </SrGridRow>
      </SrBox>
    </SrBox>
  );
};

PartnerAgentOwnerMarketingPageTestimonials.displayName =
  'PartnerAgentOwnerMarketingPageTestimonials';

export default PartnerAgentOwnerMarketingPageTestimonials;
